const THEME_KEY = 'admin-theme';
const DARK_CSS_ID = 'dark-tech-theme-style';

export function getTheme() {
    return localStorage.getItem(THEME_KEY) || 'light';
}

export function setTheme(theme) {
    localStorage.setItem(THEME_KEY, theme);
    applyTheme(theme);
}

export function applyTheme(theme) {
    document.body.setAttribute('data-theme', theme);
    if (theme === 'dark') {
        loadDarkThemeCss();
    } else {
        removeDarkThemeCss();
    }
}

function loadDarkThemeCss() {
    if (document.getElementById(DARK_CSS_ID)) {
        return;
    }
    const link = document.createElement('link');
    link.id = DARK_CSS_ID;
    link.rel = 'stylesheet';
    link.href = process.env.BASE_URL + 'style/dark-tech.css';
    document.head.appendChild(link);
}

function removeDarkThemeCss() {
    const link = document.getElementById(DARK_CSS_ID);
    if (link) {
        link.parentNode.removeChild(link);
    }
}

export function initTheme() {
    const theme = getTheme();
    applyTheme(theme);
}
